export default {
    internet_access: {
        name: "Internet Access",
        url: "nwcg_communications/internet_access",
    },
    mobile_weather_unit: {
        name: "Mobile Weather Unit",
        url: "nwcg_communications/mobile_weather_unit",
    },
    repeater: {
        name: "Repeater",
        url: "nwcg_communications/repeater",
    },
}
